<template>
  <q-avatar :icon="icon" :size="size" :font-size="fontSize" :color="color" :text-color="textColor"/>
</template>

<script>
export default {
  name: 'RAvatar',
  props: {
    icon: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
    fontSize: String,
    color: String,
    textColor: String,
  },
};
</script>
